export default function PortalNavbar() {
  const navItems = [
    { label: "首页", path: "/" },
    { label: "今日更新", path: "/#today" },
    { label: "热门排行", path: "/rankings" },
    { label: "最新爆料", path: "/latest" },
    { label: "往期回顾", path: "/#review" },
    { label: "关于我们", path: "/about" },
  ];

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/80 bg-background-50/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="/" className="group flex items-center gap-2.5" aria-label="曝光导航首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-flashlight-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">曝光导航</span>
            <span className="text-[10px] text-foreground-600">吃瓜不迷路 · 热点抢先看</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.path}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
          <a
            href="/#subscribe"
            className="ml-2 flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-notification-3-line" />
            新料提醒
          </a>
        </nav>

        {/* mobile */}
        <details className="group relative lg:hidden">
          <summary className="flex h-10 w-10 cursor-pointer list-none items-center justify-center rounded-md border border-background-200 bg-background-100">
            <i className="ri-menu-3-line text-xl text-foreground-800" />
          </summary>
          <div className="absolute right-0 top-12 flex w-52 flex-col gap-1 rounded-lg border border-background-200 bg-background-50 p-2 shadow-sm">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.path}
                className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
            <a
              href="/#subscribe"
              className="mt-1 flex items-center justify-center gap-1 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 hover:bg-primary-600"
            >
              <i className="ri-notification-3-line" />
              新料提醒
            </a>
          </div>
        </details>
      </div>
    </header>
  );
}